// Score to show on a played-match tile. The headline is always total shots;
// when a sets game was tied on sets and decided by the extra end, add a short
// note saying so, since the shots alone don't explain who won.
export function matchScoreDisplay(match, comp) {
  const display = { home: match.homeScore, away: match.awayScore, detail: null };
  if (!comp || comp.matchType !== 'sets') return display;

  const homeSets = match.homeSetsWon || 0;
  const awaySets = match.awaySetsWon || 0;
  if (homeSets === 0 || homeSets !== awaySets) return display;

  let ends = match.endScores;
  if (typeof ends === 'string') { try { ends = JSON.parse(ends); } catch (_) { ends = null; } }
  const baseEnds = Math.max(1, parseInt(comp.numberOfSets || 3, 10)) * Math.max(1, parseInt(comp.endsPerSet || 9, 10));
  let eeHome = 0, eeAway = 0;
  (Array.isArray(ends) ? ends.slice(baseEnds) : []).forEach(e => { eeHome += (e && e.home) || 0; eeAway += (e && e.away) || 0; });
  if (eeHome === eeAway) return display;

  const winner = eeHome > eeAway ? match.HomeTeam : match.AwayTeam;
  const winnerName = winner ? winner.name : (eeHome > eeAway ? 'Home' : 'Away');
  display.detail = `Sets tied ${homeSets}–${awaySets} · Extra end won by ${winnerName}`;
  return display;
}
